import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import validator from 'validator';

import MuiFormControlLabel from '@material-ui/core/FormControlLabel';
import MuiSwitch from '@material-ui/core/Switch';
import MuiTextField from '@material-ui/core/TextField';
import MuiButton from '@material-ui/core/Button';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { useMutation } from 'react-query';
import * as API from 'api';

import { sanitizeFormatCharacters } from '../../utils/format';

const Groups = API.Groups();
const styles = theme => ({
  dialog: {
    width: '300px',
  },
  formRow: {
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: '10px',
  },
  fullWidth: {
    width: '100%',
  },
  dialogFooter: {
    padding: theme.spacing(1.5),
  },
});

const DialogCreateGroup = ({ open, onClose, onCreated, ...props }) => {
  const { classes } = props;

  const { mutateAsync: createGroup, isLoading: isCreating } = useMutation(({ name, email, is_label_account }) =>
    Groups.create(name, email, is_label_account)
  );

  const [formData, setFormData] = useState({ is_label_account: false });
  const [errors, setErrors] = useState({});

  const handleFormSubmit = async evt => {
    evt.preventDefault();
    const errors = {};
    if (!validator.isEmail(formData.email)) errors.email = 'Not Valid Email';
    if (validator.isEmpty(formData.name)) errors.name = 'Not Valid Name';
    setErrors(errors);
    if (Object.keys(errors).length > 0) return;

    try {
      let data = await createGroup({
        name: formData.name,
        email: sanitizeFormatCharacters(formData.email),
        is_label_account: formData.is_label_account,
      });

      setFormData({ is_label_account: false, email: '', name: '' });
      if (typeof onCreated === 'function') {
        onCreated(data);
      }
    } catch (error) {
      if (error instanceof Error) {
        alert(error.message);
      } else if (error && error.status === 409) {
        alert('This email address is already associated with a group');
      } else {
        alert(JSON.stringify(error));
      }
    }
  };

  return (
    <MuiDialog open={open} onClose={onClose} aria-labelledby="form-dialog-title">
      <MuiDialogTitle id="form-dialog-title">Create New Group</MuiDialogTitle>
      <form onSubmit={handleFormSubmit} autoComplete="off">
        <MuiDialogContent className={classes.dialog}>
          <div className={classes.formRow}>
            <MuiTextField
              disabled={isCreating}
              autoFocus
              className={classes.fullWidth}
              value={formData.name || ''}
              margin="dense"
              name="name"
              label="Group Name"
              type="text"
              error={!!errors['name']}
              onChange={({ target: { value } }) => setFormData({ ...formData, name: value })}
            />
          </div>
          <div className={classes.formRow}>
            <MuiTextField
              disabled={isCreating}
              className={classes.fullWidth}
              margin="dense"
              name="email"
              label="Email Address"
              type="email"
              error={!!errors['email']}
              value={formData.email || ''}
              onChange={({ target: { value } }) => setFormData({ ...formData, email: value })}
            />
          </div>
          <div className={classes.formRow}>
            <MuiFormControlLabel
              label="Label Account"
              control={
                <MuiSwitch
                  disabled={isCreating}
                  name="is_label_account"
                  error={!!errors['is_label_account']}
                  checked={formData.is_label_account || false}
                  onChange={({ target: { checked } }) => setFormData({ ...formData, is_label_account: checked })}
                />
              }
            />
          </div>
        </MuiDialogContent>
        <MuiDialogActions className={classes.dialogFooter}>
          <MuiButton variant="contained" onClick={onClose} disabled={isCreating}>
            Cancel
          </MuiButton>
          <MuiButton variant="contained" color="primary" type="submit" disabled={isCreating}>
            Create
          </MuiButton>
        </MuiDialogActions>
      </form>
    </MuiDialog>
  );
};
export default withStyles(styles)(DialogCreateGroup);
